function initShopTheLook(container) {
  if (!container) return;

  const tooltipTriggers = container.querySelectorAll('.stl__trigger');
  if (tooltipTriggers.length === 0) return;

  // Check if tooltip is overflowing outside viewport and change their position
  tooltipTriggers.forEach(trigger => {
    const tooltip = trigger.nextElementSibling;
    if(!tooltip) return;

    const {left} = tooltip.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    if ((left + tooltip.offsetWidth) > windowWidth) {
      tooltip.classList.toggle('stl__tooltip--left');
    }
  })

  const closeActiveTooltips = (tooltips) => {
    tooltips.forEach(tooltip => {
      tooltip.classList.remove('stl__tooltip--active')
      tooltip.previousElementSibling?.classList.remove('stl__trigger--active');
    });
  }

  // Handle click on tooltip trigger
  tooltipTriggers.forEach(trigger => trigger.addEventListener('click', (event) => {
    const tooltip = event.target.nextElementSibling;

    // Hide tooltips that are active
    const activeTooltipsAll = Array.from(container.querySelectorAll('.stl__tooltip--active'));
    const activeTooltips = activeTooltipsAll.filter(item => item !== tooltip);
    closeActiveTooltips(activeTooltips);

    // Toggle current tooltip
    if (tooltip) {
      trigger.classList.toggle('stl__trigger--active');
      tooltip.classList.toggle('stl__tooltip--active');
    }
  }));

  // Close all tooltips when clicked outside
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('stl__trigger')) {
      return;
    }

    const activeTooltips = container.querySelectorAll('.stl__tooltip--active');
    closeActiveTooltips(activeTooltips);
  });
}

export default initShopTheLook;
